import { AccessLevel } from '@mnd-frontend/graphql-schema';
import { animated, useTransition } from '@react-spring/web';
import type { FC } from 'react';
import styled from 'styled-components';

const StyledIconPopup = styled.div`
  background-color: #ffffff;
  bottom: 2rem;
  left: 0;
  margin: 0;
  padding: 0;
  z-index: 1999;
`;

type CookieOverviewProps = {
  locale?: string;
  show: boolean;
  version?: string;
  viewAsAdmin: boolean;
  accessLevel?: AccessLevel;
};

const CookieOverview: FC<CookieOverviewProps> = ({
  locale,
  show,
  version,
  viewAsAdmin,
  accessLevel,
}) => {
  const transitions = useTransition(show, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 100 },
  });

  return (
    <>
      {transitions((style, item) =>
        item ? (
          <animated.div style={style}>
            <StyledIconPopup>
              <b>Viewing as:</b> {viewAsAdmin ? 'Admin' : 'User'}
              <br />
              <b>Access Level:</b> {accessLevel === AccessLevel.ReadWrite ? 'Read & Write' : 'Read'}
              <br />
              {version && (
                <>
                  <b>Version:</b> {version}
                  <br />
                </>
              )}
              {locale && (
                <>
                  <b>Locale:</b> {locale}
                </>
              )}
            </StyledIconPopup>
          </animated.div>
        ) : null,
      )}
    </>
  );
};

export default CookieOverview;
